<template>
  <FeathersVuexGet service="branches" :id="activeBranch" local>
    <div slot-scope="props" v-if="synced">
      <div class="topnav">
        <div class="d-flex align-items-end">
          <i
            class="las la-bars icon-menu mr-3"
            @click="$store.dispatch('toggleSidebar')"
          />
          <custom-switch
            v-if="false"
            label="aberto"
            :id="props.item._id"
            @toggled="patchBranch"
            :active="props.item.opened"
          />
        </div>
        <h5 class="m-0">{{ props.item.name }}</h5>
        <div :class="!connected ? 'no-connection' : 'connected'">
          <p v-if="!connected" class="text-danger m-0 b-0">Sem conexão</p>
          <div class="d-flex btn-align-end">
            <b-button
              class="custom-btn mr-2"
              v-b-modal.search-users
              v-if="company.prepaidEnabled"
            >
              Créditos
            </b-button>

            <b-button
              class="btn-align-end mr-2 custom-btn"
              v-b-modal.loyalty-modal
            >
              Fidelidade
            </b-button>
            <b-button
              class="btn-align-end mr-2"
              variant="danger"
              @click="logout()"
              >Sair</b-button
            >
          </div>
        </div>
      </div>

      <b-modal
        id="search-users"
        title="Procurar clientes"
        @hidden="clearSearch()"
      >
        <b-list-group horizontal center>
          <b-form-group>
            <b-form-radio
              v-model="searchPlaceholder"
              name="search-by"
              value="o e-mail"
              @change="fieldToSearch = 'email'"
            >
              E-mail
            </b-form-radio>
            <b-form-radio
              v-model="searchPlaceholder"
              name="search-by"
              value="o cpf"
              @change="fieldToSearch = 'cpf'"
            >
              CPF
            </b-form-radio>
            <b-form-radio
              v-model="searchPlaceholder"
              name="search-by"
              value="o telefone"
              @change="fieldToSearch = 'phone'"
            >
              Telefone
            </b-form-radio>
            <b-form-radio
              v-model="searchPlaceholder"
              name="search-by"
              value="a matrícula"
              @change="fieldToSearch = 'externalId'"
              v-if="company.availableModes.education"
            >
              Matrícula
            </b-form-radio>
          </b-form-group>
        </b-list-group>

        <b-form @submit.prevent="search()">
          <div class="d-flex mt-3">
            <b-form-input
              class="mr-2"
              v-model="query"
              :placeholder="'Pesquise pel' + searchPlaceholder + ' do cliente'"
              required
            />
            <b-button type="submit" class="custom-btn mr-2" :disabled="loading">
              <div
                v-if="loading"
                class="spinner-border text-white spinner-border-sm"
              ></div>
              <span v-else>Pesquisar</span>
            </b-button>
          </div>
        </b-form>
        <div v-if="user">
          <p>Nome completo: {{ user.name }}</p>
          <p>Valor disponível: {{ user.credit.available | currency }}</p>
          <b-form-group
            :label="
              `Digite o valor em reais a ser modificado de ${
                user.name.split(' ')[0]
              }`
            "
          >
            <b-form-input
              type="number"
              v-model="discountValue"
              placeholder="15"
            />

            <b-list-group horizontal>
              <b-button
                class="mt-2 mr-2 custom-btn"
                @click="handleCredits(user)"
                :disabled="discountValue == 0 || loadingAddSubButton"
              >
                <div
                  v-if="loadingAddSubButton"
                  class="spinner-border text-white spinner-border-sm"
                ></div>
                <span v-else> {{ addsubButton }} </span>
              </b-button>

              <i id="tooltipCredits">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 30 30"
                  version="1.1"
                  x="0px"
                  y="0px"
                  width="35px"
                  height="35px"
                  class="tooltipButton"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g transform="translate(7.000000, 7.000000)" fill="#000000">
                      <path
                        d="M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M7.08229167,9.96549479 L8.75807292,9.96549479 C8.76588546,9.66861831 8.80690067,9.42350357 8.88111979,9.23014323 C8.95533891,9.03678289 9.08815008,8.84830821 9.27955729,8.66471354 L9.95338542,8.03776042 C10.2385431,7.76041528 10.4455723,7.48893362 10.5744792,7.22330729 C10.7033861,6.95768096 10.7678385,6.66276204 10.7678385,6.33854167 C10.7678385,5.59635046 10.5285831,5.02409055 10.0500651,4.62174479 C9.57154709,4.21939903 8.89674915,4.01822917 8.02565104,4.01822917 C7.15064667,4.01822917 6.47096596,4.23600043 5.98658854,4.67154948 C5.50221112,5.10709853 5.25611983,5.71549089 5.24830729,6.49674479 L7.22877604,6.49674479 C7.23658858,6.20377458 7.31275969,5.97135503 7.45729167,5.79947917 C7.60182364,5.62760331 7.79127487,5.54166667 8.02565104,5.54166667 C8.53346608,5.54166667 8.78736979,5.83658559 8.78736979,6.42643229 C8.78736979,6.668621 8.71217523,6.89029847 8.56178385,7.09147135 C8.41139248,7.29264424 8.19166811,7.51432171 7.90260417,7.75651042 C7.61354022,7.99869913 7.40455794,8.28482908 7.27565104,8.61490885 C7.14674415,8.94498863 7.08229167,9.39517944 7.08229167,9.96549479 Z M6.84205729,11.7467448 C6.84205729,12.0358087 6.94654843,12.2731111 7.15553385,12.4586589 C7.36451927,12.6442067 7.62525885,12.7369792 7.93776042,12.7369792 C8.25026198,12.7369792 8.51100156,12.6442067 8.71998698,12.4586589 C8.9289724,12.2731111 9.03346354,12.0358087 9.03346354,11.7467448 C9.03346354,11.4576808 8.9289724,11.2203785 8.71998698,11.0348307 C8.51100156,10.8492829 8.25026198,10.7565104 7.93776042,10.7565104 C7.62525885,10.7565104 7.36451927,10.8492829 7.15553385,11.0348307 C6.94654843,11.2203785 6.84205729,11.4576808 6.84205729,11.7467448 Z"
                      />
                    </g>
                  </g>
                </svg>
              </i>
              <b-popover
                target="tooltipCredits"
                triggers="hover"
                placement="top"
              >
                <template #title>Dica!</template>
                O botão ficará disponível ao alterar o valor de 0. Informe um
                número positivo para somar créditos ou informe um número
                negativo para descontar.
              </b-popover>
            </b-list-group>
          </b-form-group>
        </div>
      </b-modal>

      <LoyaltyModal />
    </div>
  </FeathersVuexGet>
</template>

<script>
import CustomSwitch from "@/components/Utils/CustomSwitch.vue";
import { showToast } from "@/helpers/toast";
import LoyaltyModal from "@/components/Loyalty/Loyalty.vue";
import {
  getAccessToken,
  getActiveBranch,
  getActiveCompany,
  getActiveUser,
  removeActiveBranch,
  removeActiveCompany,
  removeActiveUser,
} from "@/helpers/storage";
import { FeathersVuexFind, FeathersVuexGet } from "feathers-vuex";
import { patch } from "@/network/rest";
import Locations from "@/network/locations";
import { mapGetters } from "vuex";
import {
  query,
  getUser,
  queryUserExternalId,
  queryUserGeneral,
} from "@/helpers/queries";
import { get } from "@/network/rest";
import moment from "moment";

export default {
  name: "topnav",
  components: {
    CustomSwitch,
    FeathersVuexGet,
    LoyaltyModal,
  },
  props: {
    connected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      queried: new Set(),
      query: "",
      loading: false,
      loadingAddSubButton: false,
      user: null,
      discountValue: 0,
      searchPlaceholder: "o e-mail",
      fieldToSearch: "email",
    };
  },
  watch: {
    user() {
      if (this.user && !this.user.credit) {
        this.user = {
          ...this.user,
          credit: {
            available: 0,
            history: [],
          },
        };
      }
    },
  },
  beforeCreate() {
    if (!this.$store.getters.isSynced) this.$router.push("/");
  },
  computed: {
    feathers() {
      return this.$FeathersVuex.api;
    },
    activeBranch: () => getActiveBranch(),
    activeUser: () => getActiveUser(),
    accessToken: () => getAccessToken(),
    activeCompany: () => getActiveCompany(),
    company() {
      return this.feathers.Company.getFromStore(this.activeCompany);
    },
    hasLoyalty() {
      const { loyalty } = this.company;
      const { points } = loyalty;

      return loyalty && points && !points.disabled;
    },
    ...mapGetters({ synced: "isSynced" }),
    addsubButton() {
      return this.discountValue >= 0 ? "Adicionar" : "Descontar";
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout").then(() => {
        this.$router.push("/");
        removeActiveBranch();
        removeActiveCompany();
        removeActiveUser();
        window.location.reload();
      });
    },
    async patchBranch(data) {
      await patch(this.accessToken, `${Locations.branches}/${data.id}`, {
        opened: data.checked,
      });
    },
    async findUser(value) {
      try {
        return await queryUserGeneral(
          this.feathers,
          this.accessToken,
          { [this.fieldToSearch]: value },
          this.activeCompany
        );
      } catch (e) {
        console.log(e);
        return null;
      }
    },
    async search() {
      this.loading = true;
      const user = await this.findUser(this.query);

      console.log("user no search", user);

      if (user) {
        console.log("aqui");
        this.user = user;
      } else {
        this.user = null;
        showToast(this, `Usuário não encontrado`, "danger");
      }
      this.query = "";
      this.loading = false;
    },
    async handleCredits(user) {
      this.loadingAddSubButton = true;
      const credit = user.credit || {
        available: 0,
        history: [],
      };
      const valAux1 = parseFloat(credit.available);
      const valAux2 = parseFloat(this.discountValue || 0);
      const historyAux = credit.history ? credit.history : [];

      const newTotal = valAux1 + valAux2;

      let newCredit = {
        available: newTotal,
        history: [
          {
            time: moment().toISOString(),
            amount: parseFloat(this.discountValue),
            previousAmount: credit.available,
            currentAmount: newTotal,
          },
        ],
      };

      newCredit.history = [...newCredit.history, ...historyAux];

      try {
        const updatedUser = await patch(
          this.accessToken,
          `${Locations.customers}/${user._id}`,
          {
            credit: newCredit,
          }
        );
        this.user = updatedUser.data;
        showToast(this, `Créditos atualizados`, "success");
      } catch (e) {
        console.log(e);
        showToast(this, `Erro o atualizar créditos`, "danger");
      }
      this.loadingAddSubButton = false;
      console.log("foi");
    },
    clearSearch() {
      this.user = null;
      this.loading = false;
      this.discountValue = 0;
      this.query = "";
    },
  },
};
</script>

<style lang="scss" scoped>
.topnav {
  background-color: #fff;
  height: $topnav-height;
  width: 100%;
  border-radius: 5px;
  box-shadow: $shadow;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;

  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  text-align: center;
}

.icon-user {
  color: $text-color;
  font-size: 2rem;
}

.icon-dropdown {
  font-size: 1.2rem;
}

.icon-menu {
  cursor: pointer;
  font-size: 2rem;
  display: none;

  @media (max-width: 1150px) {
    display: block;
  }
}

.btn-align-end {
  justify-self: end;
}

.no-connection {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.connected {
  display: contents;
}
.tooltipButton:hover {
  cursor: pointer;
  filter: invert(15%) sepia(100%) saturate(4097%) hue-rotate(262deg)
    brightness(98%) contrast(97%);
}
</style>
